import "./history.css";
import {
    Close,
    LocalGroceryStore,
    CloudDownload,
} from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHistory, voidOrder } from "../../redux/apiCalls";
import moment from "moment";
import Select from "react-select";
import { commonSelectProps } from "../../components/shared/SelectStyles";
import { publicRequest } from "../../requestMethods";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import { FiPlus } from "react-icons/fi";
import {
    getOrderProductDisplayName,
    getOrderProductLineTotal,
    getOrderProductQuantity,
    getOrderProductUnitPrice,
} from "../../utils/orderProductDisplay";

export default function History() {
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const dispatch = useDispatch();
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );
    const orders = useSelector((state) => state.order.order);
    const currentUser = useSelector((state) => state.user.currentUser);

    const marketing = useSelector((state) =>
    state.user.currentUser
        ? state.user.currentUser.type === "marketing"
        : null
);

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const userPrinciple = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const resolveDefaultPrinciple = () => {
        if (superadmin) {
            return undefined;
        }
        if (outright) {
            return currentUser?._id;
        }
        return userPrinciple || currentUser?._id;
    };

    const [inputs, setInputs] = useState({
        user: undefined,
        principle: resolveDefaultPrinciple(),
        limit: 20,
        page: 1,
    });
    const [statusMenu, setStatusMenu] = useState(false);
    const [voidMenu, setVoidMenu] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
        const principleParam = resolveDefaultPrinciple();
        setInputs((prev) => {
            if (prev.principle !== principleParam) {
                return { ...prev, principle: principleParam };
            }
            return prev;
        });
    }, [currentUser?._id, currentUser?.principle, currentUser?.type, superadmin, outright]);

    useEffect(() => {
        async function fetchData() {
          const result = await getHistory(dispatch, inputs);
          setHistoryData(result?.payload || []);
        }
        
        fetchData();
    }, [dispatch, inputs]);
      

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
    }, [usersData]);

    useEffect(() => {
        if (statusMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [statusMenu]);

    const handleVoid = (id) => {
        voidOrder(id, dispatch);
    };

    const handleUserFilter = (e) => {
        setInputs((prev) => {
            return { ...prev, user: e.value };
        });
    };

    const handleResetFilters = () => {
        setInputs({
            user: undefined,
            principle: resolveDefaultPrinciple(),
            limit: 20,
            page: 1,
        });
    };

    const fetchOrders = async (dispatch, inputs) => {
        const result = await getHistory(dispatch, inputs);
        setHistoryData(result?.payload || []);
    };

    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setUsersData(res.data);
    };

    const columns = [
        {
            Header: "Products",
            accessor: "product",
            Cell: (params) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <LocalGroceryStore
                        className="text-blue-500 hover:text-blue-700 cursor-pointer"
                        onClick={() => {
                            setModalData(params.row.original.products);
                            setStatusMenu(true);
                        }}
                    />
                </div>
            ),
        },
        {
            Header: "Customer",
            accessor: "userId",
            Cell: ({ value }) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{value ? value.name : ""}</div>
            ),
        },
        {
            Header: "Total Paid",
            accessor: "amount",
            Cell: (params) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    RM{formatter.format(params.row.original.amount - params.row.original.discount)}
                </div>
            ),
        },
        {
            Header: "Salesperson",
            accessor: "createdBy",
            Cell: ({ value }) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">{value ? value.name : ""}</div>
            ),
        },
        {
            Header: "Purchase Date",
            accessor: "createdAt",
            Cell: ({ value }) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            Header: "Payment Type",
            accessor: "paymentType",
            Cell: ({ value }) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">{value}</div>
            ),
        },
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">{value}</div>
            ),
        },
        {
            Header: "Action",
            accessor: "action",
            Cell: (params) => (
                <div className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <div className="flex space-x-2">
                        {(superadmin || accountant) && (
                            <CloudDownload
                                className="text-orange-500 hover:text-orange-700 cursor-pointer"
                                onClick={() => {
                                    createCustomerInvoice(params.row.original);
                                }}
                            />
                        )}
                        {!accountant && (
                            <Close
                                className="text-red-500 hover:text-red-700 cursor-pointer"
                                onClick={() => {
                                    setModalData(params.row.original._id);
                                    setVoidMenu(true);
                                }}
                            />
                        )}
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div className="container mx-auto px-4 py-8 block">
            {/* Header Section */}
            <div className="flex justify-between items-center mb-6">
                <button
                    onClick={handleResetFilters}
                    className="flex items-center bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
                >
                    <FiPlus className="mr-2" />
                    Reset Filters
                </button>
            </div>

            {/* Filter Panel */}
            <div className="bg-white rounded-lg shadow p-4 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Customer
                        </label>
                        <div className="react-select-container">
                            <Select
                                options={usersData.map((user, i) => {
                                    return {
                                        label: `${user.name} - ${user.phoneNumber}`,
                                        value: user._id,
                                    };
                                })}
                                placeholder="Select Customer"
                                onChange={handleUserFilter}
                                {...commonSelectProps}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop Table View */}
            <div className="history-table-container desktop-only">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-orange-400">
                        <tr>
                            {columns.map((column) => (
                                <th
                                    key={column.Header}
                                    className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
                                >
                                    {column.Header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {historyData ? historyData.map((order) => (
                            <tr key={order._id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <LocalGroceryStore
                                        className="text-blue-500 hover:text-blue-700 cursor-pointer"
                                        onClick={() => {
                                            setModalData(order.products);
                                            setStatusMenu(true);
                                        }}
                                    />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {order.userId ? order.userId.name : ""}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    RM{formatter.format(order.amount - order.discount)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                    {order.createdBy ? order.createdBy.name : ""}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {moment(order.createdAt).format("DD/MM/YYYY")}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                    {order.paymentType}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                    {order.status}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <div className="flex space-x-2">
                                        {(superadmin || accountant) && (
                                            <CloudDownload
                                                className="text-orange-500 hover:text-orange-700 cursor-pointer"
                                                onClick={() => {
                                                    createCustomerInvoice(order);
                                                }}
                                            />
                                        )}
                                        {!accountant && (
                                            <Close
                                                className="text-red-500 hover:text-red-700 cursor-pointer"
                                                onClick={() => {
                                                    setModalData(order._id);
                                                    setVoidMenu(true);
                                                }}
                                            />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={columns.length} className="px-6 py-4 text-center text-gray-500">
                                    Loading...
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                
                {/* Desktop Pagination */}
                {orders && (
                    <div className="order-list-table-footer history-pagination desktop-pagination px-4 py-3 flex items-center justify-between border-t border-gray-200">
                        <div className="order-list-table-footer-inner flex-1 flex justify-between items-center">
                            <div className="order-list-table-footer-results history-pagination-info text-sm text-gray-700">
                                Showing{' '}
                                <span className="font-medium">
                                    {((inputs.page - 1) * inputs.limit) + 1}
                                </span>
                                {' '}-{' '}
                                <span className="font-medium">
                                    {Math.min(inputs.page * inputs.limit, orders.totalPages)}
                                </span>
                                {' '}of{' '}
                                <span className="font-medium">{orders.totalPages}</span>
                                {' '}results
                            </div>
                            <div className="order-list-table-footer-pagination flex space-x-2">
                                <button
                                    onClick={() => {
                                        inputs.page = 1;
                                        fetchOrders(dispatch, inputs);
                                        setInputs((prev) => ({ ...prev, page: 1 }));
                                    }}
                                    disabled={inputs.page === 1}
                                    title="First"
                                    aria-label="First page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page === 1
                                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'bg-orange-400 text-white hover:bg-orange-500'
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&lt;&lt;</span>
                                    <span className="order-list-pagination-text">First</span>
                                </button>
                                <button
                                    onClick={() => {
                                        inputs.page = inputs.page - 1;
                                        fetchOrders(dispatch, inputs);
                                        setInputs((prev) => ({ ...prev, page: prev.page - 1 }));
                                    }}
                                    disabled={inputs.page === 1}
                                    title="Previous"
                                    aria-label="Previous page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page === 1
                                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'bg-orange-400 text-white hover:bg-orange-500'
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&lt;</span>
                                    <span className="order-list-pagination-text">Previous</span>
                                </button>
                                <span className="order-list-pagination-page px-3 py-1 bg-gray-100 text-gray-900 rounded-md text-sm font-medium">
                                    Page {inputs.page} of {Math.ceil(orders.totalPages / inputs.limit)}
                                </span>
                                <button
                                    onClick={() => {
                                        inputs.page = inputs.page + 1;
                                        fetchOrders(dispatch, inputs);
                                        setInputs((prev) => ({ ...prev, page: prev.page + 1 }));
                                    }}
                                    disabled={inputs.page >= Math.ceil(orders.totalPages / inputs.limit)}
                                    title="Next"
                                    aria-label="Next page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page >= Math.ceil(orders.totalPages / inputs.limit)
                                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'bg-orange-400 text-white hover:bg-orange-500'
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&gt;</span>
                                    <span className="order-list-pagination-text">Next</span>
                                </button>
                                <button
                                    onClick={() => {
                                        inputs.page = Math.ceil(orders.totalPages / inputs.limit);
                                        fetchOrders(dispatch, inputs);
                                        setInputs((prev) => ({ ...prev, page: Math.ceil(orders.totalPages / inputs.limit) }));
                                    }}
                                    disabled={inputs.page >= Math.ceil(orders.totalPages / inputs.limit)}
                                    title="Last"
                                    aria-label="Last page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page >= Math.ceil(orders.totalPages / inputs.limit)
                                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'bg-orange-400 text-white hover:bg-orange-500'
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&gt;&gt;</span>
                                    <span className="order-list-pagination-text">Last</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Mobile Card View */}
            <div className="history-cards-container mobile-only">
                {historyData ? historyData.map((order) => (
                    <div key={order._id} className="history-card">
                        {/* Info Section */}
                        <div className="history-card-info">
                            <div className="history-card-row">
                                <span className="history-card-label">Status:</span>
                                <span className={`history-card-status history-card-status-${order.status}`}>
                                    {order.status}
                                </span>
                            </div>

                            <div className="history-card-row">
                                <span className="history-card-label">Date:</span>
                                <span className="history-card-value">
                                    {moment(order.createdAt).format("DD/MM/YYYY")}
                                </span>
                            </div>

                            <div className="history-card-row">
                                <span className="history-card-label">Customer:</span>
                                <span className="history-card-value">
                                    {order.userId ? order.userId.name : "N/A"}
                                </span>
                            </div>

                            <div className="history-card-row">
                                <span className="history-card-label">Total Paid:</span>
                                <span className="history-card-value history-card-amount">
                                    RM{formatter.format(order.amount - order.discount)}
                                </span>
                            </div>

                            <div className="history-card-row">
                                <span className="history-card-label">Salesperson:</span>
                                <span className="history-card-value">
                                    {order.createdBy ? order.createdBy.name : "N/A"}
                                </span>
                            </div>

                            <div className="history-card-row">
                                <span className="history-card-label">Payment:</span>
                                <span className="history-card-value">
                                    {order.paymentType}
                                </span>
                            </div>

                            {/* Action Buttons */}
                            <div className="history-card-actions">
                                <button
                                    className="history-card-btn history-card-btn-products"
                                    onClick={() => {
                                        setModalData(order.products);
                                        setStatusMenu(true);
                                    }}
                                >
                                    <LocalGroceryStore style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
                                    View Products
                                </button>
                                {(superadmin || accountant) && (
                                    <button
                                        className="history-card-btn history-card-btn-download"
                                        onClick={() => {
                                            createCustomerInvoice(order);
                                        }}
                                    >
                                        <CloudDownload style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
                                        Download
                                    </button>
                                )}
                                {!accountant && (
                                    <button
                                        className="history-card-btn history-card-btn-void"
                                        onClick={() => {
                                            setModalData(order._id);
                                            setVoidMenu(true);
                                        }}
                                    >
                                        <Close style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
                                        Void Order
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )) : (
                    <div className="history-loading">
                        Loading...
                    </div>
                )}

                {/* Mobile Pagination */}
                {orders && (() => {
                    const totalCount = orders.totalPages || 0;
                    const totalPages = Math.ceil(totalCount / inputs.limit) || 1;
                    const isFirstPage = inputs.page === 1;
                    const isLastPage = inputs.page >= totalPages;
                    
                    return (
                        <div className="order-list-table-footer history-pagination mobile-pagination px-4 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="order-list-table-footer-inner flex-1 flex justify-between items-center">
                                <div className="order-list-table-footer-results history-pagination-info-mobile text-sm text-gray-700">
                                    Showing{' '}
                                    <span className="font-medium">
                                        {((inputs.page - 1) * inputs.limit) + 1}
                                    </span>
                                    {' '}-{' '}
                                    <span className="font-medium">
                                        {Math.min(inputs.page * inputs.limit, totalCount)}
                                    </span>
                                    {' '}of{' '}
                                    <span className="font-medium">{totalCount}</span>
                                    {' '}results
                                </div>
                                <div className="order-list-table-footer-pagination flex space-x-2">
                                    <button
                                        onClick={() => {
                                            inputs.page = 1;
                                            fetchOrders(dispatch, inputs);
                                            setInputs((prev) => ({ ...prev, page: 1 }));
                                        }}
                                        disabled={isFirstPage}
                                        title="First"
                                        aria-label="First page"
                                        className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                            isFirstPage
                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                : 'bg-orange-400 text-white hover:bg-orange-500'
                                        }`}
                                    >
                                        <span className="order-list-pagination-icon" aria-hidden>&lt;&lt;</span>
                                        <span className="order-list-pagination-text">First</span>
                                    </button>
                                    <button
                                        onClick={() => {
                                            inputs.page = inputs.page - 1;
                                            fetchOrders(dispatch, inputs);
                                            setInputs((prev) => ({ ...prev, page: prev.page - 1 }));
                                        }}
                                        disabled={isFirstPage}
                                        title="Previous"
                                        aria-label="Previous page"
                                        className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                            isFirstPage
                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                : 'bg-orange-400 text-white hover:bg-orange-500'
                                        }`}
                                    >
                                        <span className="order-list-pagination-icon" aria-hidden>&lt;</span>
                                        <span className="order-list-pagination-text">Previous</span>
                                    </button>
                                    <span className="order-list-pagination-page px-3 py-1 bg-gray-100 text-gray-900 rounded-md text-sm font-medium">
                                        Page {inputs.page} of {totalPages}
                                    </span>
                                    <button
                                        onClick={() => {
                                            inputs.page = inputs.page + 1;
                                            fetchOrders(dispatch, inputs);
                                            setInputs((prev) => ({ ...prev, page: prev.page + 1 }));
                                        }}
                                        disabled={isLastPage}
                                        title="Next"
                                        aria-label="Next page"
                                        className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                            isLastPage
                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                : 'bg-orange-400 text-white hover:bg-orange-500'
                                        }`}
                                    >
                                        <span className="order-list-pagination-icon" aria-hidden>&gt;</span>
                                        <span className="order-list-pagination-text">Next</span>
                                    </button>
                                    <button
                                        onClick={() => {
                                            inputs.page = totalPages;
                                            fetchOrders(dispatch, inputs);
                                            setInputs((prev) => ({ ...prev, page: totalPages }));
                                        }}
                                        disabled={isLastPage}
                                        title="Last"
                                        aria-label="Last page"
                                        className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                            isLastPage
                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                : 'bg-orange-400 text-white hover:bg-orange-500'
                                        }`}
                                    >
                                        <span className="order-list-pagination-icon" aria-hidden>&gt;&gt;</span>
                                        <span className="order-list-pagination-text">Last</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </div>

            {/* Modals */}
            {statusMenu && (
                <div className="overlayContainer">
                    <div className="bigcenter">
                        <div
                            className="close"
                            onClick={() => setStatusMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="updatemodalContainer">
                            <div className="updateOrder">
                                <h1 className="updateProductTitle text-xl font-semibold">
                                    Products({modalData.length})
                                </h1>
                                <div className="table-wrapper bg-white rounded-lg shadow overflow-x-auto">
                                    <table className="history-products-table min-w-full divide-y divide-gray-200">
                                        <thead className="bg-orange-400">
                                            <tr>
                                                <th className="history-products-col-name px-4 py-3 text-left text-xs font-semibold text-black uppercase tracking-wider">
                                                    Name
                                                </th>
                                                <th className="history-products-col-qty px-4 py-3 text-center text-xs font-semibold text-black uppercase tracking-wider">
                                                    Quantity
                                                </th>
                                                <th className="history-products-col-price px-4 py-3 text-right text-xs font-semibold text-black uppercase tracking-wider">
                                                    Unit Price
                                                </th>
                                                <th className="history-products-col-total px-4 py-3 text-right text-xs font-semibold text-black uppercase tracking-wider">
                                                    Total Price
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {modalData.map((product, index) => {
                                                const qty =
                                                    getOrderProductQuantity(
                                                        product
                                                    );
                                                const unitPrice =
                                                    getOrderProductUnitPrice(
                                                        product
                                                    );
                                                const lineTotal =
                                                    getOrderProductLineTotal(
                                                        product
                                                    );

                                                return (
                                                    <tr
                                                        key={index}
                                                        className="hover:bg-gray-50"
                                                    >
                                                        <td className="history-products-col-name px-4 py-3 text-sm text-gray-900 align-top">
                                                            {getOrderProductDisplayName(
                                                                product
                                                            )}
                                                        </td>
                                                        <td className="history-products-col-qty px-4 py-3 text-sm text-gray-900 text-center whitespace-nowrap">
                                                            {qty}
                                                        </td>
                                                        <td className="history-products-col-price px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                                                            RM{" "}
                                                            {formatter.format(
                                                                unitPrice
                                                            )}
                                                        </td>
                                                        <td className="history-products-col-total px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                                                            RM{" "}
                                                            {formatter.format(
                                                                lineTotal
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {voidMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setVoidMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Void Order?
                                </h3>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleVoid(modalData);
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
